<template>
  <div>
    <b-card class="standardpage">

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="chold_reset">*EVENTS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-purple">{{ gtotal }}</span>
        </b-nav-item>
        <!-- {{ events }} -->
        <b-nav-item v-if="zevent.eventcode" class="nav-pills-hover-effect border-secondary" small
          v-for="(zevent, index) in events" :key="zevent"
          @click="agent = null; slac = [], eventcode = [zevent.eventcode]" :active="zevent.eventcode == eventcode[0]">
          <span :id="'event_name_' + index" :class="zevent.eventcode == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zevent.eventcode"></span>
          <span :id="'event_count_' + index" class="ml-1 badge badge-purple">{{ zevent.count }}</span>

          <span v-if="parseFloat(zevent.aged) > 0" :id="'event_aged_' + index" class="ml-1 badge badge-danger">{{
            zevent.aged }}</span>

          <b-tooltip :target="'event_name_' + index" placement="top">{{ zevent.name }}</b-tooltip>

          <b-tooltip :target="'event_count_' + index" placement="top">{{ zevent.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'event_aged_' + index" placement="top">{{ zevent.aged }} charge(s) have been delayed in
            Conferma Inventory for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <hr />

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="chold_reset">*SLACS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-purple">{{ gtotal }}</span>
        </b-nav-item>
        <b-nav-item v-if="zclient.slac" class="nav-pills-hover-effect border-secondary" small
          v-for="(zclient, index) in clients" :key="zclient"
          @click="agent = null; eventcode = []; slac = [zclient.slac]" :active="zclient.slac == slac[0]">
          <span :id="'slac_name_' + index" :class="zclient.slac == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zclient.slac"></span>

          <span :id="'slac_count_' + index" class="ml-1 badge badge-purple">{{ zclient.count }}</span>

          <!-- <span :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{ zclient.aged }}</span> -->
          <span v-if="parseFloat(zclient.aged) > 0" :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{
            zclient.aged }}</span>

          <b-tooltip :target="'slac_name_' + index" placement="top">{{ zclient.name }}</b-tooltip>

          <b-tooltip :target="'slac_count_' + index" placement="top">{{ zclient.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'slac_aged_' + index" placement="top">{{ zclient.aged }} charge(s) have been delayed in
            Conferma Inventory for
            longer
            than a
            week!</b-tooltip>

        </b-nav-item>
      </b-nav>

      <hr />

      <b-card-header class="pt-2 pb-2">
        <b-row>
          <b-col cols="auto" v-if="!agents.find(o => o.agent == agent)">
            <span class="badge badge-purple text-2x pt-0 pb-1 ml-0">Select an agent to view inventory
              <span v-if="user.permissions.includes('conferma.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col cols="auto" class="text-right" v-else>

            <span class="badge badge-purple text-2x pt-0 pb-1"> {{agents.find(o => o.agent ==
              agent) ? agents.find(o => o.agent == agent).name : ""}}
              <span v-if="user.permissions.includes('conferma.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col class="text-right strong"> Count:
            <span id="ihold_ztotal" class="ml-1 badge badge-purple text-3x pt-0 pb-1">{{ ztotal }}</span>
            <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced conferma inventory waiting.</b-tooltip>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="mt-4 availtable datatable">
        <b-row>
          <b-col>
            <b-avatar-group v-for="(zdepartment, gindex) in departments" :key="gindex" size="34px" overlap="0"
              class="inline mr-1 mt-1 ml-2 text-center p-1 avatar_dept avatarbadge">
              <span class="text-primary pt-2 mr-1">{{ zdepartment }}</span>
              <!-- border-secondary px-2 strong -->
              <div v-for="(zagent, index) in agents.filter(a => a.department == zdepartment)" :key="index">
                <span @click="change_agent(zagent.agent)" :id="zagent.agent + '_' + zagent.department + '_1'">
                  <b-avatar class="mr-1 z-auto" :text="zagent.agent" :badge="zagent.count"
                    badge-variant="purple"></b-avatar>
                </span>
                <b-tooltip :target="zagent.agent + '_' + zagent.department + '_1'" placement="bottom">{{ zagent.name }}
                </b-tooltip>
              </div>

            </b-avatar-group>
          </b-col>
        </b-row>

        <b-row class="excelsheetbuttons " no-gutters>
          <b-col>
            <span class="small text-primary">{{ message_count }}</span> </b-col>
        </b-row>

      </div>

      <div v-if="!component" class="availtable datatable">


        <b-card v-if="chold.filter" class="w-100pct mb-3">
          <b-card-body class="py-0">

            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                  <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                    placeholder="Show all..."></treeselect>
                </b-form-group> -->

                <b-form-group label-cols="12" label="Type" label-size="sm">
                  <treeselect placeholder="Show all..." searchPromptText="Supplier Type..." v-model="type"
                    :clearable="true" :multiple="true" :options="options_suppliertype">
                  </treeselect>
                </b-form-group>

              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Transaction Id ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="id" v-model="referenceno" tag-variant="primary" separator=" ,;"
                          placeholder="Paste ID (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                          remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Deployment Id ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="token" v-model="token" tag-variant="primary" separator=" ,;"
                          placeholder="Paste ID (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                          remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="token = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.min" :debounce="chold.debounce" placeholder="(min)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.min"
                            @click="cost.min = null; cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (max)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.max" :debounce="chold.debounce" placeholder="(max)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.max"
                            @click="cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>




              <b-col cols="12" sm="6" md="4" xl="3" class="display-none">
                <b-form-group label-cols="12" label="Source" label-size="sm">
                  <treeselect placeholder="Select source..." v-model="mssql" :clearable="false"
                    :options="options_source" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="!user.permissions.includes('conferma.admin')">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group> </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="user.permissions.includes('conferma.admin')">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group> </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <treeselect placeholder="Select status..." v-model="status" :multiple="true" :clearable="false"
                        :options="options_status" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- {{ chold.groupbydeployment }} -->
        <div class="px-3 mt-2 mb-2">
          <e-table classdivtable="availtable datatable w-100pct" refid="conferma" :busy="chold.busy" :icon="chold.icon"
            :selectmode="'none'" :showtoolbar="true" :showfab="false" :showsheets="false" :showrowcount="true"
            :showautoadd="false" :showpages="true" :offset="chold.offset" :limit="chold.limit" :page="chold.page"
            :toolbarlibrary="chold.toolbarlibrary" :tools="chold.tools" :badges="chold.badges" :fields="chold.fields"
            :items="chold.items" @click="chold_click" @select="chold_select" @load="chold_load">
          </e-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="chold.selected" :config="cconfig" @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"></component>
      </div>
      <b-card-footer>
        <b-row class="mt-2">
          <b-col><span class="small" v-html="message"></span> </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <!-- {{ slac }}<br/>
    {{ eventcode }}<br/>
    {{ agent }} -->
    <!-- {{ clients }} -->
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Chold",
  async mounted() {
    this.accessdenied();
    await this.chold_reset()
  },
  watch: {
    async referenceno() {
      await this.chold_load();
    },
    async token() {
      await this.chold_load();
    },
    async slac() {
      await this.chold_load();
    },
    async blac() {
      await this.chold_load();
    },
    async datetravel() {
      await this.chold_load();
    },
    async type() {
      await this.chold_load();
    },
    async eventcode() {
      await this.chold_load();
    },
    async agent() {
      await this.chold_load();
    },
    async status() {
      await this.chold_load();
    },
    "cost.min": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (!this.cost.max) { this.cost.max = this.cost.min }
        await this.chold_load(0)
      }
    },
    "cost.max": {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.chold_load(0)
      }
    },
  },

  data() {
    return {
      busy: false,
      message: "",
      gtotal: 0,
      ztotal: 0,
      events: [],
      clients: [],
      agents: [],
      departments: [],
      options_departments: [],
      email: "",
      agent: "",
      fullname: "",
      message_count: "",
      isblocked: "0",
      showblocked: false,
      readonly: false,
      eventcode: [],
      slac: [],
      blac: ['BCARDCONF', 'SVPCONF', 'SVPCONFU'],
      datetravel: {
        startDate: null,
        endDate: null,
      },
      cost: {
        min: null,
        max: null,
      },
      type: [],
      options_suppliertype: [],
      options_type: [
        { id: "AIR", label: "Air Ticketed" },
        { id: "LOW", label: "Low Cost" },
        { id: "HTL", label: "Hotels" },
        { id: "CAR", label: "Cars" },
        { id: "XFR", label: "Transfers" },
        { id: "RAI", label: "Rail/Eurostar" },
        { id: "BAG", label: "Baggage" },
        { id: "MTG", label: "Meetings" },
        { id: "OTH", label: "Other" },
        // { id: "BMD", label: "Business" },
        // { id: "visa", label: "Visa" },
      ],
      referenceno: [],
      token: [],
      agent: null,
      mssql: true,
      status: ["ready"],
      options_status: [
        { id: "ready", label: "Ready" },
        { id: "pending", label: "Pending" },
        { id: "offline", label: "Offline" },
      ],
      source: "svpconfu,svpconf,bcardconf",
      options_source: [
        { id: false, label: "Booking Forms" },
        { id: true, label: "API" },
      ],
      chold: {
        title: "Conferma",
        icon: "fa fa-credit-card text-purple",
        debounce: 1000,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter,groupbydeployment",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-sort-numeric-asc text-purple",
            position: "toolbar",
            action: "groupbydeployment",
            label: "Group By Deployment On",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-check-square-o text-primary",
            position: "toolbar",
            action: "ready",
            label: "Ready",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "citem",
            label: "Chold Inventory",
            type: "icinvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        groupbydeployment: true
      },
    };
  },
  async mounted() {
    await this.accessdenied();
    try {
      const response = await this.$apollo.query({
        query: gql`
            query suppliertypes {
            suppliertypes {
                id
                label
                faicon
            }
            }
        `,
      });
      // this.options_suppliertype = response.data.suppliertypes;
      this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
    } catch (error) {
      console.log(error);
    }
    await this.chold_load(0);
  },
  methods: {
    accessdenied() {
      this.chold.denied = [];
      if (!this.user.permissions.includes("conferma.delete")) {
        this.chold.denied.push("delete");
      }
      if (!this.user.permissions.includes("conferma.save")) {
        this.chold.denied.push("save");
      }
      if (this.user.permissions.includes("conferma.admin")) {
        this.chold.tools = "go,filter,groupbydeployment,ready,pending,reset"
      }
    },
    async change_agent(agent) {
      this.agent = agent
      await this.chold_load();
    },
    async chold_reset() {
      console.log("chold_reset");
      let state = this.chold;
      state.items = []
      this.eventcode = []
      this.slac = []
      this.agent = null
      this.gtotal = 0
      await this.chold_events_load()
      await this.chold_clients_load()
      await this.chold_agents_load()
    },
    async chold_reload() {
      await this.chold_events_load()
      await this.chold_clients_load()
      await this.chold_agents_load()
      await this.chold_load();
    },
    async chold_agents_load() {
      console.log("chold_agents_load");
      let variables = {
        type: 'byagent',
        source: 'chold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        eventcode: this.eventcode ? this.eventcode.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                    $type: String
                    $status: String
                    $source: String
                    $blac: String
                    $eventcode: String
                    $slac: String
                ) {
                  ihold_counts(
                      type: $type
                      source: $source
                      status: $status
                      blac: $blac
                      eventcode: $eventcode
                      slac: $slac
                ) {
                    count
                    agent
                    email
                    name
                    department
                }
                }
            `,
          variables,
        });

        this.agents = response.data.ihold_counts;

        this.departments = [...new Set(this.agents.map(a => a.department))].sort()

        this.ztotal = 0
        for (var i = 0; i < this.agents.length; ++i) {
          this.ztotal += parseInt(this.agents[i].count)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async chold_events_load() {
      console.log("chold_events_load");
      let variables = {
        type: 'byevent',
        source: 'chold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query chold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    eventcode
                    name
                }
                }
            `,
          variables,
        });

        this.events = response.data.ihold_counts;

      } catch (error) {
        console.log(error);
      }
    },
    async chold_clients_load() {
      console.log("chold_clients_load");
      let variables = {
        type: 'byclient',
        source: 'chold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query chold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    slac
                    name
                }
                }
            `,
          variables,
        });

        this.clients = response.data.ihold_counts;

        this.ztotal = 0
        for (var i = 0; i < this.clients.length; ++i) {
          this.ztotal += parseInt(this.clients[i].count)
        }
        if (!this.agent) {
          this.gtotal = this.ztotal
        }

      } catch (error) {
        console.log(error);
      }
    },
    async chold_load(offset, limit, page) {
      console.log("chold_load", offset, limit, page);

      if (this.events.length == 0) { await this.chold_events_load() }
      if (this.clients.length == 0) { await this.chold_clients_load() }
      if (this.agents.length == 0) { await this.chold_agents_load() }

      let state = this.chold;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      // NO WILDCARD SEARCHES
      if (
        !this.agent && this.slac.length == 0 && this.eventcode.length == 0
      ) {
        this.message = ""
        return;
      }

      state.busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        groupby: this.chold.groupbydeployment ? 'deployment' : null,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        token: this.token.length > 0 ? this.token.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
        datetravel: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        agent: this.agent,
        source: 'chold',
        cost: this.cost.min ? [this.cost.min, this.cost.max] : null,
      };

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query ihold(
                $offset: Int
                $limit: Int
                $groupby: String
                $eventcode: String
                $slac: String
                $blac: String
                $type: String
                $datetravel: [String]
                $referenceno: String
                $reference: String
                $token: String
                $status: String
                $source:String
                $agent: String
                $cost: [String]
              ) {
                ihold(
                  offset: $offset
                  limit: $limit
                  groupby: $groupby
                  eventcode: $eventcode
                  slac: $slac
                  blac: $blac
                  type: $type
                  datetravel: $datetravel
                  referenceno: $referenceno
                  reference: $reference
                   token: $token
                  status: $status
                  source: $source
                  agent: $agent
                  cost: $cost
                ) {
                  id
                  referenceno                  
                  blac                  
                  eventcode
                  eventname
                  slac
                  slacname
                  yourref
                  cost
                  sale
                  vat
                  margin
                  markup
                  total
                  invoiceno
                  posted
                  notes
                  agent
                  lines {
                    id
                    type
                    issued_at
                    last4                    
                    referenceno
                    reference
                    token                    
                    routing
                    remark               
                    locator
                    start_at
                    end_at
                    details
                    description
                    passenger
                    qty
                    sale
                    vat
                    markup
                    total
                    costlocal
                    costlocalcurrency
                    costcurrency                
                    cost
                    blac
                    slac
                    eventcode
                    margin
                    agent
                    agentname
                    notes
                    expanded
                    claimed
                  }
                  tags
                  data
                  groupby
                  rows
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.ihold
        } else {
          state.items = []
          // STABLE ROW IDENTITY (tp_server#20): key each row by its line ids so
          // e-table keys rows by record, not position - prevents inline-editor
          // state bleeding onto other rows when paging.
          response.data.ihold.forEach(row => {
            let ids = [];
            (row.lines || []).forEach(l => { if (l.id != null) ids.push(l.id); });
            row.uid = [...new Set(ids)].sort().join('-');
          });
          state.items = response.data.ihold;
        }
        console.log(response.data.ihold)

      } catch (error) {
        console.log(error);
      }

      await this.chold_clients_load()
      await this.chold_agents_load()

      state.busy = false;
    },

    async chold_click(a, ss, tools) {
      console.log("chold_click", a, ss, tools);

      let tool = null

      switch (a) {
        case "filter":
          this.chold.filter = !this.chold.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "go":
          await this.chold_reload()
          this.$store.dispatch("chold");
          break;
        case "groupbydeployment":
          tool = tools.find((o) => o.action == a);
          this.chold.groupbydeployment = !this.chold.groupbydeployment
          if (this.chold.groupbydeployment) {
            tool.label = "Group By Deployment On"
          } else {
            tool.label = "Group By Deployment Off"
          }
          await this.chold_agents_load()
          await this.chold_load();
          break;
        case "ready":
          this.status = ['ready']
          await this.chold_reload()
          break;
        case "pending":
          this.status = ['pending']
          await this.chold_reload()
          break;
        case "reset":
          this.status = ['ready']
          this.blac = ['BCARDCONF', 'SVPCONF', 'SVPCONFU']
          this.slac = []
          this.eventcode = []
          await this.chold_reload()
          break;
      }
    },
    async chold_select(ss, tools) {
      console.log("chold_select", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "export", "groupbydeployment", 'ready', 'pending', 'reset'];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.chold.selected = ss;
    },
    async postit(s) {
      console.log("postit", s);
      s[0].posted = true
      await this.chold_clients_load()
      this.$store.dispatch("chold");
    },

  },
};
</script>